import axiosInstance from '../axiosInstance';

/**
 * 워크숍 후기 목록.
 *
 * @returns {Promise<{averageRating:number, reviewCount:number, canWrite:boolean,
 *   myReview:object|null, reviews:Array}>}
 */
export const getWorkshopReviews = async (workshopId) => {
  try {
    const response = await axiosInstance.get(`/workshops/${workshopId}/reviews`);
    return response.data.data;
  } catch (error) {
    console.error('Get Workshop Reviews API Error:', error);
    throw error;
  }
};

/** 작성·수정. 이미 쓴 후기가 있으면 덮어쓴다. */
export const submitWorkshopReview = async (workshopId, { rating, content }) => {
  try {
    const response = await axiosInstance.post(
      `/workshops/${workshopId}/reviews`,
      { rating, content },
    );
    return response.data.data;
  } catch (error) {
    console.error('Submit Workshop Review API Error:', error);
    throw error;
  }
};

export const deleteMyWorkshopReview = async (workshopId) => {
  try {
    await axiosInstance.delete(`/workshops/${workshopId}/reviews/me`);
  } catch (error) {
    console.error('Delete Workshop Review API Error:', error);
    throw error;
  }
};
